<template>
    <div>
        <div class="yslx">
            <div class="nav">
                <div style="width: 1140px;margin: 0 auto;display: flex;justify-content: space-between">
                    <div class="left">
                        <div class="l-img">
                            <a href="/"><img src="../assets/yslx/assets/LOGO02-bai.png" alt="logo"></a>
                        </div>
                        <div class="n-border"></div>
                        <div class="n-font">
                            <div class="n-title">更懂艺术留学</div>
                            <div class="n-text">Open your mind</div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="l-phone">
                            <img src="../assets/yslx/assets/phone.png" alt="">
                        </div>
                        <div class="phone">400-0999-530</div>
                    </div>
                </div>

            </div>

            <!-- 头部banner -->
            <div class="banner">
                <!--        <img src="../assets/yslx/assets/banner-600-6.png" alt="">-->
                <!-- 头部立即咨询 -->
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">

                    <div class="zixun01">
                        <div class="zx">立即咨询</div>
                        <div class="a-img">
                            <img src="../assets/yslx/assets/jiantou-h.png" alt="">
                        </div>
                    </div>

                </a>
                <div class="top">
                    <div class="top-a">工业建筑</div>
                    <div class="top-a">时尚设计</div>
                    <div class="top-a">时尚/艺术商科</div>
                    <div class="top-a">视觉艺术</div>
                    <div class="top-a">数字媒体</div>
                    <div class="top-a">通识艺术</div>
                </div>
            </div>


            <!-- 内容 -->
            <div class="conten">
                <!-- 标题 -->
                <div class="bt-logo">
                    <img src="../assets/yslx/assets/biaoti.png" alt="">
                    <div class="bt-title">ROSSO学员成功申请艺术名校</div>
                </div>
                <div class="r-box">
                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/pratt.png" alt="">
                            <div class="b-title">Pratt 普瑞特艺术学院</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user1.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">yang</div>
                                        <div style="font-family: PingFangSC-Regular;
                                font-size: 16px;
                                color: #999999;
                                letter-spacing: 0;margin-top: 8px">室内设计</div>
                                    </div>
                                </div>
                                <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 72,000</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/a900480cbf03fe2f7b225248de38ff9f-2.png" alt="">
                            <div class="b-title">CCA 加州艺术学院</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user2.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">Xuan</div>
                                        <div style="font-family: PingFangSC-Regular;
                                    font-size: 16px;
                                    color: #999999;
                                    letter-spacing: 0;margin-top: 8px">插画设计</div>
                                    </div>
                                </div>
                                <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 40,000</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/420e6ff45b8b48498ab51be647d1c688.png" alt="">
                            <div class="b-title">RCA 皇家艺术学院</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user3.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">Linglu</div>
                                        <div style="font-family: PingFangSC-Regular;
                                        font-size: 16px;
                                        color: #999999;
                                        letter-spacing: 0;margin-top: 8px">纯艺术</div>
                                    </div>
                                </div>
                                <!-- <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 72,000</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/5aa5e5cd7aec6.png" alt="">
                            <div class="b-title">NYU 纽约大学</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user4.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">Jacquelyn</div>
                                        <div style="font-family: PingFangSC-Regular;
                                            font-size: 16px;
                                            color: #999999;
                                            letter-spacing: 0;margin-top: 8px">游戏设计</div>
                                    </div>
                                </div>
                                <!-- <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 72,000</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/timg.png" alt="">
                            <div class="b-title">CMU 卡内基梅隆大学</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user5.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">jiangtao</div>
                                        <div style="font-family: PingFangSC-Regular;
                                                font-size: 16px;
                                                color: #999999;
                                                letter-spacing: 0;margin-top: 8px">交互设计</div>
                                    </div>
                                </div>
                                <!-- <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 72,000</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="b-img">
                            <img src="../assets/yslx/assets/timg-2.png" alt="">
                            <div class="b-title">Parsons 帕森斯设计学院</div>
                        </div>
                        <!-- 卡片内容 -->
                        <div class="cart">
                            <div class="b-user">
                                <div class="b-left">
                                    <div class="b-pic">
                                        <img src="../assets/yslx/assets/user.png" alt="">
                                    </div>
                                    <div class="b-cart">
                                        <div class="name">Yuwen</div>
                                        <div style="font-family: PingFangSC-Regular;
                                                    font-size: 16px;
                                                    color: #999999;
                                                    letter-spacing: 0;margin-top: 8px">服装设计</div>
                                    </div>
                                </div>
                                <!-- <div class="b-right">
                                    <div class="money">奖学金</div>
                                    <div class="money">$ 72,000</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <div class="zixun02">
                        <div class="zx">咨询留学条件</div>
                        <div class="a-img">
                            <img src="../assets/yslx/assets/jiantou.png" alt="">
                        </div>
                    </div>
                </a>
            </div>

            <!-- 独家优势 -->
            <div style="padding-top:49px">
                <!-- 标题 -->
                <div class="c-logo">
                    <img src="../assets/yslx/assets/biaoti02.png" alt="">
                    <div class="c-title">ROSSO留学的独家优势</div>
                </div>

                <div class="c-box">
                    <div class="main">
                        <div style="margin-top: 18px;
                        margin-left: 18px;
                        margin-bottom: 18px;display: flex;">
                            <div class="m-pic">
                                <img src="../assets/yslx/assets/b9a5b6df-6551-4fdd-8c7c-3836ab1c2826.png" alt="">
                            </div>
                            <div class="m-right">
                                <div class="m-title">自研基础课纲</div>
                                <div class="borders"></div>
                                <ul>
                                    <li>根据学生基础定制化教学</li>
                                    <li>五重审核体系提高课程质量及深度</li>
                                    <li>四级教学法步步提升</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="main">
                        <div style="margin-top: 18px;
                            margin-left: 18px;
                            margin-bottom: 18px;display: flex;">
                            <div class="m-pic">
                                <img src="../assets/yslx/assets/st1.png" alt="">
                            </div>
                            <div class="m-right">
                                <div class="m-title">多V1教育系统</div>
                                <div class="borders"></div>
                                <ul>
                                    <li>每位学员配备2-3位老师</li>
                                    <li>主线老师带专业项目，辅线分软件课老师、基础课手绘课老师、跨专业辅导老师</li>
                                    <li>全程1对1可视化教学</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="main">
                        <div style="margin-top: 18px;
                                margin-left: 18px;
                                margin-bottom: 18px;display: flex;">
                            <div class="m-pic">
                                <img src="../assets/yslx/assets/2-3.png" alt="">
                            </div>
                            <div class="m-right">
                                <div class="m-title">申请和规划双把控</div>
                                <div class="borders"></div>
                                <ul>
                                    <li>申请老师，整合学生材料，个人简历、陈述、选校等写作，材料递</li>
                                    <li>规划老师，结合学生学校和家庭资源匹配活动方案，结合ROSSO内部资源，为学生提供的实习机会、时间安排等</li>
                                    <!-- <li>四级教学法步步提升</li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="main">
                        <div style="margin-top: 18px;
                                    margin-left: 18px;
                                    margin-bottom: 18px;display: flex;">
                            <div class="m-pic">
                                <img src="../assets/yslx/assets/st.png" alt="">
                            </div>
                            <div class="m-right">
                                <div class="m-title">Offer Plus 高校衔接课</div>
                                <div class="borders"></div>
                                <ul>
                                    <li>英美主流大学大一大二以及研一研二的课程大纲</li>
                                    <li>老师根据大纲提前授课，提前进入国外的授课模式以及课程了解</li>
                                    <!-- <li>四级教学法步步提升</li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 免費留学评估 -->

                <!-- 弹出框 -->
                <!-- 按钮触发模态框 -->
                <!--            <div class="banner2" data-toggle="modal" data-target="#myModal">-->
                <div class="banner2">
                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img src="../assets/yslx/assets/ad-01.png"
                            alt=""></a>
                </div>

                <!-- 模态框（Modal） -->
                <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="modal-img">
                                    <img src="../assets/yslx/assets/LOGO-black.png" alt="">
                                </div>
                                <h4 class="modal-title" id="myModalLabel">不要错过上名校的机会</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>


                            </div>
                            <form id="id_form">
                                <div class="modal-body">
                                    <div class="modal-input">
                                        <span>姓名:</span>
                                        <span><input type="text" name="name"></span>
                                    </div>
                                    <div class="modal-input">
                                        <span>电话:</span>
                                        <span>
                                            <input type="text" autocomplete="off" name="phone" id="phone"
                                                @blur="upperCase()">
                                        </span>
                                        <div style="font-family: PingFangSC-Regular;
                                        font-size: 12px;
                                        color: #DE7666;
                                        letter-spacing: 0;display: none" id="tishi">请输入正确的手机号</div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <!--                            <button type="button" class="btn">提交</button>-->
                                    <button type="button" class="btn" value="sumbit" @click="onSubmit()">提交</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 产品体系完善  按需定制课程 -->
            <div style="padding-top:50px;background: #f5f5f5">
                <div class="c-logos4">
                    <img src="../assets/yslx/assets/biaoti.png" alt="">
                    <div class="c-title">产品体系完善 按需定制课程</div>
                </div>
                <div class="r-box2">
                    <div class="box2">
                        <div class="logo233">
                            <img src="../assets/yslx/assets/deng.png" alt="">
                        </div>
                        <div class="b-text">创意基础课程</div>
                        <div class="b-txt">【您将获得】独立的艺术鉴赏力、创造力与审美力，激发学生的艺术潜能，也是专业作品集课程的衔接课程。</div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="zixun03" id="zixun">
                                <div class="zixun">
                                    <img id="zx-img" src="../assets/yslx/assets/zixun.png" alt="">
                                </div>
                                <div class="zxxx" id="zxxx">咨询详情</div>
                            </div>
                        </a>
                    </div>
                    <div class="box2">
                        <div class="logo233">
                            <img src="../assets/yslx/assets/zuoping.png" alt="">
                        </div>
                        <div class="b-text">专业作品集课程</div>
                        <div class="b-txt">【您将获得】量身定制的满足申请要求的作品集，产出3-5个项目，自主能力和专业能力得到提升。</div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="zixun03" id="zixun1">
                                <div class="zixun">
                                    <img id="zx-img1" src="../assets/yslx/assets/zixun.png" alt="">
                                </div>

                                <div class="zxxx" id="zxxx01">咨询详情</div>

                            </div>
                        </a>
                    </div>
                    <div class="box2">
                        <div class="logo233">
                            <img src="../assets/yslx/assets/xuexiao.png" alt="">
                        </div>
                        <div class="b-text">名校背景提升</div>
                        <div class="b-txt">【您将获得】提高艺术素养，丰富申请履历，写出独一无二文书，核心竞争力更强。</div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="zixun03" id="zixun02">
                                <div class="zixun">
                                    <img id="zx-img2" src="../assets/yslx/assets/zixun.png" alt="">
                                </div>

                                <div class="zxxx" id="zxxx2">咨询详情</div>

                            </div>
                        </a>
                    </div>
                    <div class="box2">
                        <div class="logo233">
                            <img src="../assets/yslx/assets/zstq.png" alt="">
                        </div>
                        <div class="b-text">VIP院校录取计划</div>
                        <div class="b-txt">【您将获得】英美权威专业（或自选）TOP3、TOP5、TOP8名校offer，艺术设计思维和艺术综合能力，提前适应国外艺术课程体系。</div>
                        <div class="b-txt">【课程内容】创意基础、必备技能强化、专业作品集、offer plus、英文Critique、海外名校教授Tutorial、实习推荐。</div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="zixun03" id="zixun03">
                                <div class="zixun">
                                    <img id="zx-img3" src="../assets/yslx/assets/zixun.png" alt="">
                                </div>

                                <div class="zxxx" id="zxxx3">咨询详情</div>

                            </div>
                        </a>
                    </div>
                    <div class="box2">
                        <div class="logo233">
                            <img src="../assets/yslx/assets/huojian.png" alt="">
                        </div>
                        <div class="b-text">Offer Plus 高校衔接课程</div>
                        <div class="b-txt">【您将获得】专业技能巩固提高，进入梦想校后能快速适应今后的国际艺术学习、生活。</div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="zixun03" id="zixun04">
                                <div class="zixun">
                                    <img id="zx-img4" src="../assets/yslx/assets/zixun.png" alt="">
                                </div>

                                <div class="zxxx" id="zxxx4">咨询详情</div>

                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- 免费试听 -->
            <!--        <div class="banner2" data-toggle="modal" data-target="#myModal">-->
            <div class="banner2">
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img src="../assets/yslx/assets/ad.png" alt=""></a>
            </div>
            <!--  -->
            <div style="padding-top:50px">
                <div class="c-logo04" style="margin-bottom: 57px;">
                    <img src="../assets/yslx/assets/biaoti04.png" alt="">
                    <div class="c-title04">ROSSO福利 丰富的活动&实习机会</div>
                </div>
                <div class="r-box3">
                    <div class="box3">
                        <div class="pic">
                            <img src="../assets/yslx/assets/huodong01.png" id="pic" alt="">
                        </div>
                    </div>
                    <div class="box3">
                        <div class="pic">
                            <div style="display: flex;" id="biaoti01">
                                <div class="left">
                                    <img src="../assets/yslx/assets/01.png" alt="">
                                </div>
                                <div class="right">
                                    <div class="r-text">
                                        <a>UAL纯艺导师带你详细分析如何成功申请UAL、RCA</a>
                                    </div>
                                    <div class="dotted">
                                        <img src="../assets/yslx/assets/zhixian.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;" id="biaoti02">
                                <div class="left">
                                    <img src="../assets/yslx/assets/02.png" alt="">
                                </div>
                                <div class="right">
                                    <div class="r-text">
                                        <a> RCA女装毕业导师，带你掌握能放进作品集中的快速立裁技巧</a>
                                    </div>
                                    <div class="dotted">
                                        <img src="../assets/yslx/assets/zhixian.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;" id="biaoti03">
                                <div class="left">
                                    <img src="../assets/yslx/assets/03.png" alt="">
                                </div>
                                <div class="right">
                                    <div class="r-text">
                                        <a>
                                            Parsons教授全国行程公开，申请+专业干货全get！
                                        </a>
                                    </div>
                                    <div class="dotted">
                                        <img src="../assets/yslx/assets/zhixian.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;" id="biaoti04">
                                <div class="left">
                                    <img src="../assets/yslx/assets/04.png" alt="">
                                </div>
                                <div class="right">
                                    <div class="r-text">
                                        <a>
                                            交互编程新体验，NYU教授亲自教学！
                                        </a>
                                    </div>
                                    <div class="dotted">
                                        <img src="../assets/yslx/assets/zhixian.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;" id="biaoti05">
                                <div class="left">
                                    <img src="../assets/yslx/assets/05.png" alt="">
                                </div>
                                <div class="right">
                                    <div class="r-text">
                                        <a> RCA、UCL双背景建筑外教，9大环节带你层层突破英国建筑申请！</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="r-crossing"></div>
                    <div class="b-crossing"></div>
                </div>

                <!--            <div class="huodong" data-toggle="modal" data-target="#myModal">-->
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <div class="huodong">
                        <div class="h-btn">免费参与活动</div>
                        <div class="jiantou"><img src="../assets/yslx/assets/jiantou.png" alt=""></div>
                    </div>
                </a>
            </div>
            <!-- 底部轮播 -->
            <div style="padding-top: 50px;padding-bottom: 70px;background: #f5f5f5">
                <div class="c-logo05" style="margin-bottom: 57px;">
                    <img src="../assets/yslx/assets/biaoti05.png" alt="">
                    <div class="c-title05">全国七大校区 就近上课更便捷</div>
                </div>
                <div id="demo" class="carousel slide" data-ride="carousel">
                    <!-- 轮播图片 -->
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class="r-box4">
                                <div class="box4">
                                    <div class="b-btn">北京</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/BJ.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            北京市朝阳区百子湾路苹果社区北区32号院6号楼88号
                                        </div>
                                    </div>
                                </div>
                                <div class="box4">
                                    <div class="b-btn">成都</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/chengdu.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            成都锦江区成都国际金融中心IFS
                                        </div>
                                    </div>
                                </div>
                                <div class="box4">
                                    <div class="b-btn">广州</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/guangzhou.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            广州天河区天河北路233号中信广场
                                        </div>
                                    </div>
                                </div>
                                <div class="box4">
                                    <div class="b-btn">深圳</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/shenzhen.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            深圳市福田区金田路东福华路北岗厦皇庭中心37楼
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="r-box4">
                                <div class="box4">
                                    <div class="b-btn">上海</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/shanghai.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            上海徐汇区文定路208号A座301-302室
                                        </div>
                                    </div>
                                </div>
                                <div class="box4">
                                    <div class="b-btn">南京</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/nanjing.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            南京市秦淮区中山南路1号南京中心20楼
                                        </div>
                                    </div>
                                </div>
                                <div class="box4">
                                    <div class="b-btn">杭州</div>
                                    <div class="bjx">
                                        <img src="../assets/yslx/assets/hangzhou.png" alt="">
                                    </div>
                                    <div class="b4">
                                        <div class="b-left4">
                                            <img src="../assets/yslx/assets/ditu.png" alt="">
                                        </div>
                                        <div class="b-right4">
                                            杭州市西湖区学院路77号黄龙万科中心H座7层
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- 左右切换按钮 -->
                        <!--                    <a class="carousel-control-prev" href="#demo" data-slide="prev">-->
                        <!--                        <span class="carousel-control-prev-icon"></span>-->
                        <!--                    </a>-->
                        <!--                    <a class="carousel-control-next" href="#demo" data-slide="next">-->
                        <!--                        <span class="carousel-control-next-icon"></span>-->
                        <!--                    </a>-->
                    </div>
                    <!-- 指示符 -->
                    <ul class="carousel-indicators" style="list-style-type: none;">
                        <li data-target="#demo" data-slide-to="0"
                            style="margin-left:3px;width: 12px;height: 12px;border-radius: 50%" class="active"></li>
                        <li data-target="#demo" data-slide-to="1"
                            style="margin-left:3px;width: 12px;height: 12px;border-radius: 50%"></li>
                    </ul>
                </div>
            </div>
            <div class="foots1">
                <div class="foots1-title">
                    <span class="span1">咨询热线：</span>
                    <span class="span2">400-0999-530</span>
                </div>
                <div class="foots1-text">沪ICP备19007600号-1 © 2016-2019 上海洛素文化艺术有限公司 版权所有</div>
            </div>
        </div>

        <!-- foot -->

        <!-- foot -->
    </div>
</template>
<script>
// import '@/assets/yslx/js/jquery.min.js'
// import '@/assets/yslx/files/js/bootstrap.min.js'
// import '@/assets/yslx/files/index-pc/index-pc.js'
// import '@/assets/yslx/files/index-pc/form.js'
// import '@/assets/yslx/files/index-pc/modal.js'
// import "@/assets/yslx/files/index-pc/bootstrap.min.css"
// import "@/assets/yslx/files/index-pc/index-pc.css"
export default {
    data() {
        return {

        }
    },
    methods: {
        upperCase() {

            var phone = document.getElementById('phone').value;
            var tishi = document.getElementById('tishi')
            if (!(/^1[34578]\d{9}$/.test(phone))) {

                tishi.style.display = 'block'
                return false;

            }
        },
        onSubmit() {
            /* 可以通过两种方法获取文件 */

            // 通过FormData的append方法动态添加属性
            var nameVal = $("input[name='name']").val();
            var phoneVal = $("input[name='phone']").val();
            var formData = new FormData();
            formData.append("name", nameVal);
            formData.append("tel", phoneVal);

            console.log(phoneVal)

            // 通过Ajax实现上传
            $.ajax({
                url: "https://public.rossoarts.com/index/Form/addForm",
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                // headers: {
                //     // 'Access-Token':$.cookie('access_token')
                //     'Access-Token':200
                // },
                success: function (data) {
                    console.log("response success: ", data);
                },
                error: function (error) {
                    alert("response error: ", error);
                }
            });
        }
    }
}
</script>
<style>
#newcefu li {
    list-style: none;
    margin-left: -40px
}

.carousel-inner {
    width: 1140px;
    margin: 0 auto;
    height: 330px;
}

.carousel-indicators {
    bottom: -50px;
    margin-left: 14.4%;
}

.carousel-indicators li {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ffffff;
    border: 1px solid black;
    margin-top: 80px;
}

.carousel-indicators .active {
    background: #333333;
}

.carousel-inner img {
    width: 100%;
    height: 100%;
}

.modal-title {
    font-family: PingFang-SC-Bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    margin: 0 auto;
}

.modal-img {
    width: 48px;
    height: 40px;
}

.modal-img img {
    width: 100%;
    height: 100%;
}

.modal-input {
    width: 300px;
    margin: 0 auto;
    margin-bottom: 29px;
    margin-top: 20px;
}

.btn {
    width: 180px;
    height: 50px;
    line-height: 10px;
    background: #A3E6D7;
    border-radius: 3px;
    border-radius: 3px;
    border: none;
    margin: 0 auto;
    /* font-family: PingFang-SC-Bold; */
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    border-color: transparent;
    outline: none;
}

.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;

}

.btn:hover {
    background: #FBADA1;
    width: 180px;
    height: 50px;
    line-height: 10px;
    border-radius: 3px;
    border-radius: 3px;
    border: none;
    margin: 0 auto;
    /* font-family: PingFang-SC-Bold; */
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    border: 0;
    outline: none;
}

input {
    -webkit-appearance: none;
    appearance: none;
    display: inline-block;
    margin: 0 2px 2px 0;
    width: 200px;
    cursor: pointer;
    outline: none;
    vertical-align: middle;
    border: 1px solid #DCDCDC;
}

/* span:nth-child(2) {
    margin-left: 20px;

} */

.modal-footer {
    border: none;
}

/*body {margin:0;padding:0;}*/
.yslx .banner {
    width: 100%;
    background: url("../assets/yslx/assets/banner-600-6.png") no-repeat center;
    position: relative;
    height: 600px;
    /*margin:0 auto;*/
    object-fit: cover;
}

.yslx .banner img {
    width: 100%;
    object-fit: cover;
}

.yslx .a-img {
    width: 17.3px;
    height: 14.6px;
    /* margin-top: 23px; */
    margin-left: 10px;
}

.yslx .banner .zx {
    text-align: center;
    margin-left: 43px;
}

.yslx .zixun01 {
    display: flex;
    width: 200px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    background: #FBADA1;
    border-radius: 2px;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    position: absolute;
    bottom: 73px;
    left: 50%;
    margin-left: -100px
}

.yslx .top {
    width: 1140px;
    height: 60px;
    line-height: 60px;
    /*margin:0 auto;*/
    background: #FFFFFF;
    display: flex;
    /* box-shadow:#333333;*/
    position: absolute;
    bottom: -25px;
    /*left:190px;*/
    text-align: center;
    justify-content: space-between;
    box-shadow: 0px 0px 1px #cccccc;
    left: 50%;
    margin-left: -570px;
}

.yslx .top-a {
    font-size: 22px;
    color: #333333;
    width: 17%;
    height: 29px;
    text-align: center;
    line-height: 29px;
    border-right: 1px solid #EBEBEB;
    margin-top: 15px;
}

.yslx .conten {
    background: #f5f5f5;
    padding-bottom: 40px;
    padding-top: 80px;
}

.yslx .bt-logo {
    margin: 0 auto;
    width: 525px;
    height: 49px;
    position: relative;
}

.yslx .bt-logo img {
    width: 100%;
    height: 100%;
}

.yslx .bt-title {
    font-weight: bold;
    font-family: PingFang-SC-Bold;
    font-size: 26px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    position: absolute;
    top: 5px;
    left: 80px;
}

.yslx .b-cart {
    margin-left: 10px;
}

.yslx .r-box {
    width: 1140px;
    margin: 0 auto;
    margin-top: 53px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap
}

.yslx .box {
    width: 370px;
    height: 362px;
    background: #FFFFFF;
    /* box-shadow:0px 0px 6px #cccccc;*/
    box-shadow: 0px 1px 5px #cccccc;
    margin-bottom: 30px;
}

.yslx .b-img {
    width: 100%;
    height: 252px;
    position: relative;
}

.yslx .b-img img {
    width: 100%;
    height: 100%;
}

.yslx .b-title {
    background: #333333;
    /* width:50%;*/
    height: 48px;
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 48px;
    position: absolute;
    top: 0;
    padding-left: 19px;
    padding-right: 13px;
}

.yslx .b-user {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    /* border:1px solid red;*/
    margin-top: 25px;
}

.yslx .b-left {
    display: flex;
    justify-content: space-between;
}

.yslx .b-left {
    /* border:1px solid red;*/
    height: 60px;
}

.yslx .b-pic {
    width: 60px;
    height: 60px;
}

.yslx .b-pic img {
    width: 100%;
    height: 100%;
}

.yslx .name {
    font-family: PingFang-SC-Bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.yslx .money {
    font-family: PingFang-SC-Bold;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
}

.yslx .money:nth-child(2) {
    margin-top: 10px;
}

.yslx .zixun02 {
    display: flex;
    width: 224px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    background: #333333;
    border-radius: 2px;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
}

.yslx .zixun02 .zx {
    text-align: center;
    margin-left: 53px;
}

.yslx .c-box {
    width: 1140px;
    /* border:1px solid red;*/
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 46px;
    flex-wrap: wrap
}

.yslx .c-logo {
    margin: 0 auto;
    width: 525px;
    height: 58px;
    position: relative;
}

.yslx .c-title {
    font-weight: bold;
    position: absolute;
    top: 5px;
    left: 120px;
    font-family: PingFang-SC-Bold;
    font-size: 26px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
}

.yslx .main {
    width: 565px;
    height: 240px;
    background: #FFFFFF;
    border: 1px solid #333333;
    margin-bottom: 30px;
}

.yslx .m-right {
    width: 350px;
}

.yslx .m-pic {
    width: 196px;
    height: 204px;
}

.yslx .m-title {
    font-weight: bold;
    font-family: PingFang-SC-Bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    margin-left: 21px;
}

.yslx .borders {
    background: black;
    width: 80px;
    height: 1px;
    margin-left: 22px;
    margin-top: 10px;
    margin-bottom: 27px;
}

.yslx ul {
    height: 26px;
    line-height: 26px;
}

.yslx ul li {
    font-size: 14px;
    width: 294px;
    margin-top: 10px
}

.yslx .banner2 {
    width: 100%;
    height: 130px;
    object-fit: cover;
}

.yslx img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.yslx .r-box2 {
    width: 1140px;
    /* border:1px solid red;*/
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
}

.yslx .r-box2 a {
    display: contents;
}

.yslx .box2 {
    width: 370px;
    height: 346px;
    /* border:1px solid black;*/
    background: #FFFFFF;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.10);
    margin-bottom: 30px;
}

.yslx .box2:nth-child(4) {
    width: 754px;
    height: 346px;
    /* border:1px solid black;*/
    background: #FFFFFF;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.10);
}

.yslx .box2:nth-child(4) .b-txt {
    width: 600px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    margin-top: 25px;
    letter-spacing: 0;
    height: 30px;
}

.yslx .logo233 {
    width: 40px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
}

.yslx .b-text {
    font-family: PingFang-SC-Bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    margin-top: 14.5px;
}

.yslx .b-txt {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    width: 322px;
    height: 82px;
    margin: 0 auto;
    margin-top: 30px;
}

.yslx .zixun03 {
    border: 1px solid #333333;
    border-radius: 2px;
    border-radius: 2px;
    width: 220px;
    height: 46px;
    margin: 0 auto;
    text-align: center;
    line-height: 46px;
    background: #333333;
    display: flex;
    margin-top: 40px;
    align-items: center;
}

.yslx .zixun {
    width: 17.3px;
    height: 16.9px;
    line-height: 42px;
    margin-left: 54.4px;
    /* margin-top: 14px; */
    display: flex;
    align-items: center;
}

.yslx .zxxx {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    margin-left: 10.3px;
    text-align: center;
}

.yslx .c-logo04 {
    margin: 0 auto;
    width: 696px;
    height: 58px;
    position: relative;
}

.yslx .c-title04 {
    font-weight: bold;
    position: absolute;
    top: 5px;
    left: 145px;
    font-family: PingFang-SC-Bold;
    font-size: 26px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
}

.yslx .r-box3 {
    /* border:1px solid red;*/
    position: relative;
    width: 1140px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.yslx .box3 {
    width: 564px;
    height: 428px;
    border: 1px solid black;
}

.yslx .pic {
    width: 524px;
    height: 348px;
    margin: 0 auto;
    margin-top: 40px;
}

.yslx .left {
    width: 26px;
    height: 27px;
}

.yslx .right {
    margin-bottom: 28px;
}

.yslx .r-crossing {
    width: 40px;
    height: 2px;
    background: #333333;
    position: absolute;
    top: 55px;
    left: 48%;
}

.yslx .b-crossing {
    width: 40px;
    height: 2px;
    background: #333333;
    position: absolute;
    left: 48%;
    bottom: 50px
}

.yslx .r-text {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #333333;
    height: 27px;
    line-height: 29px;
    letter-spacing: 0;
    margin-left: 22px;
}

.yslx .dotted {
    margin-left: 22px;
    width: 462px;
    height: 2px;
    margin-top: 23px
}

.yslx .c-logo05 {
    margin: 0 auto;
    width: 616px;
    height: 58px;
    position: relative;
    margin-bottom: 46px;
}

.yslx .c-title05 {
    font-weight: bold;
    position: absolute;
    top: 5px;
    left: 145px;
    font-family: PingFang-SC-Bold;
    font-size: 26px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
}

.yslx .r-box4 {
    width: 1140px;
    margin: 0 auto;
    display: flex;
    /* justify-content:space-between;flex-wrap:wrap;*/
}

.yslx .box4 {
    width: 275px;
    height: 330px;
    border: 1px solid black;
    margin-right: 10px;
    background: #FFFFFF
}

.yslx .b-btn {
    width: 100px;
    height: 36px;
    line-height: 36px;
    background: #333333;
    margin: 0 auto;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
}

.yslx .bjx {
    width: 260px;
    height: 180px;
    margin: 0 auto;
    margin-top: 30px;
}

.yslx .b4 {
    width: 260px;
    margin: 0 auto;
    display: flex;
    margin-top: 20px;
}

.yslx .b-left4 {
    width: 20px;
    height: 23px;
}

.yslx .b-left4 img {
    width: 18px;
    height: 20px;
}

.yslx .b-right4 {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #333333;
    margin-left: 20px;
    /* letter-spacing:0;*/
}

.yslx .huodong {
    background: #333333;
    border-radius: 2px;
    border-radius: 2px;
    width: 224px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    display: flex;
    margin-top: 50px;
    text-align: center;
    margin-bottom: 40px;
}

.yslx .h-btn {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    margin-left: 43px;
}

.yslx .jiantou {
    width: 17.3px;
    height: 14.6px;
    margin-left: 13.4px;
    /* margin-top: 24px */
}

.yslx a {
    text-decoration: none;
    color: #000;
}

.yslx a:hover {
    font-weight: bold;
    text-decoration: none
}

.yslx .foots1 {
    width: 100%;
    background-color: #333333;
    height: 160px;
}

.yslx .foots1-title {
    text-align: center;
    padding-top: 49px
}

.yslx .foots1-title .span1 {
    margin: 0;
    font-size: 14px;
    text-align: center;
    color: #999999;
    font-family: PingFang-SC-Bold;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
}

.yslx .foots1-title .span2 {
    margin: 0;
    font-size: 20px;
    text-align: center;
    color: #999999;
    font-family: PingFang-SC-Bold;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
}

.yslx .foots1-text {
    margin-top: 23px;
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
}

.yslx .nav {
    width: 100%;
    height: 64px;
    background: #333333;
}

.yslx .nav .left .l-img {
    width: 62px;
    height: 52px;
    margin-top: 5px;
}

.yslx .nav .right .l-phone {
    width: 20px;
    height: 20px;
    margin-top: 21px;
}

.yslx .nav .right {
    display: flex;
}

.yslx .nav .right .phone {
    color: #f5f5f5;
    margin-left: 13px;
    margin-top: 18px;
}

.yslx .c-logos4 {
    width: 616px;
    height: 58px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 57px;
}

.yslx .c-logos4 .c-title {
    font-weight: bold;
    position: absolute;
    top: 5px;
    left: 150px;
    font-family: PingFang-SC-Bold;
    font-size: 26px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
}


.yslx .nav .left .n-border {
    width: 1px;
    height: 32px;
    background: rgba(255, 255, 255, 0.16);
    margin-left: 17px;
    margin-top: 15px;
}

.yslx .nav .left .n-font {
    margin-left: 27px;
    margin-top: 15px;
    color: rgba(255, 255, 255, 0.85);

}

.yslx .nav .left .n-font .n-title {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    letter-spacing: 0;
}

.yslx .nav .left .n-font .n-text {
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85);
    letter-spacing: 0;
    white-space: nowrap;
}

.yslx .nav .left {
    display: flex;
    width: 200px;
}
</style>